import { AutoMap } from "@automapper/classes";

export class AppareilMesure {
    @AutoMap()
    Debitmetre?: string;
    @AutoMap()
    Thermohygroanemometre?: string;
}